module.exports = __webpack_public_path__ + "img/WhatsApp Image 2020-09-19 at 4.37.31 PM (1).692db269.jpeg";